// 定义中文繁体语言包对象
export default {
  Language: '中文繁體',
  // 导航栏
  nav_cashier: '收銀台',
  
  // 支付收银台
  payment_title: '支付收銀台',
  payment_amount_label: '請輸入支付金額',
  payment_method_title: '選擇支付方式',
  payment_method_wechat: '微信支付',
  payment_method_alipay: '支付寶',
  payment_method_unionpay: '銀聯',
  payment_button: '立即支付 HK${amount}',
  payment_loading: '支付中...',
  
  // 支付调起页面
  payment_password_title: '請輸入支付密碼',
  payment_password_placeholder: '請輸入6位支付密碼',
  payment_password_hint: '請在{paymentMethod}中輸入支付密碼',
  payment_cancel: '取消',
  payment_confirm: '確認支付',
  
  // 支付成功提示
  payment_success: '支付成功',
  payment_amount: '支付金額：',
  payment_method: '支付方式：',
  payment_transaction_id: '交易號：',
  payment_time: '支付時間：',
  payment_ok: '確定',
  
  // 弹窗提示
  payment_amount_error: '請輸入有效的支付金額',
  payment_password_error: '請輸入6位支付密碼',
  
  // 银联支付
  unionpay_scan_title: '銀聯二維碼支付',
  unionpay_scan_hint: '請下載二維碼後使用雲閃付APP掃碼支付',
  unionpay_download_button: '下載二維碼',
  unionpay_download_success: '二維碼已保存到相冊',
  unionpay_download_failed: '下載失敗，請重試',
  unionpay_mobile_save_hint: '長按圖片，選擇"儲存圖片"即可',
  unionpay_desktop_save_hint: '請在新視窗中右鍵儲存圖片',
  unionpay_mobile_long_press: '長按儲存圖片'
};